export enum HolterFileType {
    diary = 'diary',
    recording = 'recording',
}
